import store from './store.js'
import './theme.less'
import init from '../init.js'
import {actions} from './siteActions.js'

init({
  store
}, actions)

window.addEventListener( 'storage' , e => {
  if( e.key === 'infoUsuario') {
      setLoggeadoEnContexto( e.newValue );
  }
});

window.addEventListener( 'civii-check-loggeado', e => {
  setLoggeadoEnContexto( sessionStorage.getItem('infoUsuario') );
})

function setLoggeadoEnContexto( usuario ){
  window.civii.$store.commit('setContextLoggeado', usuario ? true : false);
}



// WEBPACK FOOTER //
// ./src/servicios_digitales/index.js